export default __webpack_public_path__ + "static/media/pavurya3.61ad1a5d.jpg";